export class PageSequence {
    sequenceId: string;
    name: string;
    isDeleted: boolean;
    isEdited: boolean;
}
